import React from "react";

export const formatEAN = (ean: string) => {
  if (ean.length === 13) {
    return `${ean[0]} ${ean.slice(1, 7)} ${ean.slice(7)}`;
  }
  return ean;
};

interface EANViewProps {
  ean: string;
}

export const EANView: React.FC<EANViewProps> = ({ ean }) => {
  const formatted = formatEAN(ean);

  if (formatted.length <= 4) {
    return <span>{formatted}</span>;
  }

  const mainPart = formatted.slice(0, -4);
  const underlinedPart = formatted.slice(-4);

  return (
    <span>
      {mainPart}
      <span
        style={{
          borderBottom: "2px solid rgb(155, 155, 155)",
          marginLeft: "3px"
        }}
      >
        {underlinedPart}
      </span>
    </span>
  );
};
